import { LoadingIndicator, RenderWhen } from "../../../../components";
import SelectRowsProvider from "../../../../enhancers/SelectRowsProvider";
import useAttributionData from "../../hooks/useAttributionData";
import MalwareFamilyCard from "./cards/MalwareFamilyCard";
import ActorIOC from "./cards/ActorIOC";
import ActorSources from "./cards/ActorSources";

interface MalwareFamilyInsightsTabContentProps {
  ioc: string;
  threatName?: string;
  sourceId?: number;
}

const MalwareFamilyInsightsTabContent = ({
  ioc,
  threatName,
  sourceId
}: MalwareFamilyInsightsTabContentProps) => {
  const { combinedIOCs, combinedSources, isCombinedActorDataLoading } =
    useAttributionData({ ioc, threatName });

  return (
    <div className="flex flex-column flex-gap-3">
      <MalwareFamilyCard
        threatName={threatName}
        hash={ioc}
        sourceId={sourceId}
        showLink={false}
        renderThreatAdditionalInfo
      />
      <RenderWhen
        condition={!isCombinedActorDataLoading}
        fallback={<LoadingIndicator />}
      >
        <SelectRowsProvider>
          <ActorIOC iocs={combinedIOCs} />
        </SelectRowsProvider>
        <ActorSources sources={combinedSources} />
      </RenderWhen>
    </div>
  );
};

export default MalwareFamilyInsightsTabContent;
